const yesNo = (v) => (v ? 'Yes' : 'No')

export default yesNo
